module.exports = __webpack_public_path__ + "img/minion_render.7764daac.jpg";